import DateRangeField from "./DateRangeField";
import WizardStepHeader from "./WizardStepHeader";
import type { ChainFormState } from "./wizardTypes";

type Props = {
  state: ChainFormState;
  disabled: boolean;
  onChange: (updater: (state: ChainFormState) => ChainFormState) => void;
};

export default function StepSchedule({ state, disabled, onChange }: Props) {
  const setDateRange = (dateRange: ChainFormState["dateRange"]) =>
    onChange((prev) => ({ ...prev, dateRange }));

  return (
    <div className="flex flex-col gap-6" dir="rtl">
      <WizardStepHeader title="انتخاب زمان اجرا" />

      <DateRangeField
        value={state.dateRange}
        onChange={setDateRange}
        disabled={disabled}
      />
    </div>
  );
}
